const isCorrectPage = () =>
  document.body.classList.contains('teachers-page') &&
  document.querySelector('.school-application-form__form');

const handleActiveClass = (input, label) => {
  const toggleActiveClass = isActive =>
    label.classList[isActive ? 'add' : 'remove']('is-active');

  const handleFocus = () => toggleActiveClass(true);
  const handleBlur = () => toggleActiveClass(input.value != '');

  toggleActiveClass(input.value != '');

  input.addEventListener('focus', handleFocus);
  input.addEventListener('blur', handleBlur);
};

if (isCorrectPage()) {
  const fields = document.querySelectorAll(
    '.school-application-form__form .field'
  );
  fields.forEach(field => {
    const input = field.querySelector('input:not([type="hidden"]), textarea');
    const label = field.querySelector('label');
    if (input && label) {
      handleActiveClass(input, label);
    }
  });
}
